import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { LevelCourse } from 'frontend/types/learningPathV2';
import Vue from 'vue';

export interface LearningPathCourse {
  course: LevelCourse;
  level_highlighted_image_url: string;
  level_number: number;
}
interface NextLearningPathCourseState {
  data?: LearningPathCourse;
}

const nextLearningPathCourse: Module<NextLearningPathCourseState, RootState> = {
  namespaced: true,
  state: { data: undefined },
  getters: {
    nextLearningPathCourse: state => state.data,
  },
  mutations: {
    setValue(state: NextLearningPathCourseState, value: LevelCourse): void {
      Vue.set(state, 'data', value);
    },
  },
};

export default nextLearningPathCourse;
